import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import './style.css'

const app = createApp(App)

// Sentry error capture — only active when VITE_SENTRY_DSN is configured.
// DSN is set in .env.local or the Cloudflare Pages env dashboard.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.1,
  })
}

app.use(router).mount('#app')

// Cloudflare Web Analytics — injected at runtime so the token can come from
// an env var and the script is skipped entirely in local dev without a token.
const cfAnalyticsToken = import.meta.env.VITE_CF_ANALYTICS_TOKEN as string | undefined
if (cfAnalyticsToken) {
  const script = document.createElement('script')
  script.defer = true
  script.src = 'https://static.cloudflareinsights.com/beacon.min.js'
  script.dataset.cfBeacon = JSON.stringify({ token: cfAnalyticsToken })
  document.head.appendChild(script)
}

// Development-only: floating debug console. Skipped under automation
// (navigator.webdriver) — eruda's floating toggle button sits bottom-right and
// would intercept pointer events on overlapping UI like the grid zoom control.
if (import.meta.env.DEV && !navigator.webdriver) {
  import('./dev/DevConsole')
    .then(({ initDevConsole }) => {
      initDevConsole()
    })
    .catch((error) => {
      console.error('Failed to initialize DevConsole:', error)
    })
}
